var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccountBannerSparkle = function SvgIconAccountBannerSparkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 50,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 1.167,
    y: 0.5,
    fill: "#fff",
    rx: 24.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061e21",
    d: "M25.238 22.808a.452.452 0 0 1 .857 0l.806 2.421a3.61 3.61 0 0 0 2.286 2.285l2.42.806a.452.452 0 0 1 0 .858l-2.421.806a3.61 3.61 0 0 0-2.285 2.286l-.806 2.42a.451.451 0 0 1-.857 0l-.806-2.421a3.61 3.61 0 0 0-2.285-2.285l-2.421-.806a.45.45 0 0 1 0-.858l2.42-.806a3.61 3.61 0 0 0 2.286-2.285zm-4.828-6.373a.271.271 0 0 1 .514 0l.484 1.453a2.17 2.17 0 0 0 1.371 1.37l1.453.485a.27.27 0 0 1 0 .515l-1.453.483a2.17 2.17 0 0 0-1.37 1.371l-.485 1.453a.27.27 0 0 1-.514 0l-.484-1.453a2.17 2.17 0 0 0-1.371-1.37l-1.453-.485a.271.271 0 0 1 0-.515l1.453-.483a2.17 2.17 0 0 0 1.37-1.371zm8.835-1.31a.181.181 0 0 1 .342 0l.323.967c.143.432.482.77.915.915l.967.322a.182.182 0 0 1 .088.276.2.2 0 0 1-.088.067l-.967.322a1.45 1.45 0 0 0-.915.915l-.323.967a.18.18 0 0 1-.342 0l-.323-.967a1.44 1.44 0 0 0-.915-.915l-.966-.322a.181.181 0 0 1 0-.343l.968-.322c.432-.144.77-.483.915-.915z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 1.167,
    y: 0.5,
    stroke: "#EAEAEA",
    rx: 24.5
  })));
};
export default SvgIconAccountBannerSparkle;